import {useContext} from "react"
import {StProjectsContext} from "../contexts/StProjectsContext"

export function useStProjectsContext() {
    const context = useContext(StProjectsContext)
    if (!context) {
        throw new Error("useStProjectsContext must be used within a StProjectsContext")
    }
    return context
}